import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { AppConfig } from '../config/app.config';
import { url } from 'inspector';
import { catchError, map, Observable, of, switchMap, throwError } from 'rxjs';
import { PreferredReports } from '../enums/config.enum';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PRService {
  private prPrimaryURL: string | null = null;
  private prSecondaryURL: string | null = null;
  prPrimaryUrl: string = '';
  prSecondaryUrl: string = '';
  http = inject(HttpClient);
  private Url = AppConfig.apiUrl;
  private apiKey = AppConfig.apiKey;
  private urlsSignal = signal<{ [key: string]: string }>({});
  httpClient = inject(HttpClient);
  private apiUrl = AppConfig.apiUrl;
  private prUrl = AppConfig.propertyUrl;

  constructor() { }

  setApiUrls(urls: { [key: string]: string }) {
    this.urlsSignal.set(urls);
  }

  get apiUrls() {
    return this.urlsSignal.asReadonly();
  }

  getUrl(key: string): string | undefined {
    return this.urlsSignal()[key];
  }

  fetchConfig() {
    const path = `/api/SystemConfig/GetAllSystemConfig`
    const encodedPath = encodeURIComponent(path);
    const url = `${this.Url}/Proxy?path=${encodedPath}`;    
    return this.http.get<any[]>(url).pipe(
      map((configs) => {
        const config = configs[0];
        this.prPrimaryURL = config?.prPrimaryURL;
        this.prSecondaryURL = config?.prSecondaryURL;
        return { primary: this.prPrimaryURL, secondary: this.prSecondaryURL };
      })
    );
  }

  GetAllSystemConfig(){
    const path = `/api/SystemConfig/GetAllSystemConfig`
    const encodedPath = encodeURIComponent(path);
    return this.httpClient.get(`${this.apiUrl}/Proxy?path=${encodedPath}`);
  }

  fetchBuildingDetails(payload: any) {
    const headers = new HttpHeaders({ 'API-KEY': this.apiKey });

    return this.fetchConfig().pipe(
      switchMap(({ primary, secondary }) => {
        return this.http
          .post(`${primary}`, this.constructPayload(payload), { headers })
          .pipe(
            catchError(() => {
              if (secondary) {
                return this.http.post(`${secondary}`, this.constructPayload(payload), { headers });
              } else {
                return throwError(() => new Error('Both primary and secondary Preferred Reports API calls failed.'));
              }
            })
          );
      })
    );
  }

  private constructPayload(addressRequestBody: any) {
    const quoteNo = sessionStorage.getItem("indicationNo");
    const { city, state, zipcode, street, streetNum, unitNum } = addressRequestBody;
    return {
      Addresses: [
        {
          externalRequestId: quoteNo,
          subRequestId: PreferredReports.subRequestId,
          streetNumber: String(streetNum),
          unit: String(unitNum),
          city: String(city),
          state: String(state),
          zipcode: String(zipcode),
          streetName: String(street),
        },
      ],
    };
  }

fetchBulkBuildingDetails(body: any, prPrimaryUrl: string, prSecondaryUrl: string): Observable<any> {
  const headers = new HttpHeaders({
    'API-KEY': this.apiKey,
  });

  return this.httpClient.post(prPrimaryUrl, body, { headers }).pipe(
    catchError(error => {
      // Try secondary URL if primary fails
      return this.httpClient.post(prSecondaryUrl, body, { headers });
    })
  );
}

getClientIpAddress(): Observable<string> {
  return this.http.get<any>('https://api.ipify.org?format=json').pipe(
    map(res => res.ip),
    catchError(() => of('UNKNOWN'))
  );
}

logApiRequest(logPayload: any) {
    const path='/api/logging-endpoint'
    const encodedPath = encodeURIComponent(path);
    return this.http.post(`${this.apiUrl}/Proxy?path=${encodedPath}`, logPayload); // Replace with actual URL
}



}
